<template>
	<div
		class="tffi-card tffi-card-secondary-with-bg-card theming primary-color clickable-card"
		@click="navigateToCalculator"
		style="cursor: pointer;"
	>
		<div class="tffi-card-secondary-with-bg-card__content-hidden">
			<p class="capitalize">{{ programType }} Payment</p>
			<p v-if="financedAmount">Financed Amount: ${{ financedAmount | formatMoney }}</p>
			<p>Payment: ${{ periodPayment | formatMoney }}</p>
		</div>
		<div v-if="programType != 'Lease'" class="tffi-card-secondary-with-bg-card__content">
			<p v-if="financedAmount">Financed Amount: ${{ financedAmount | formatMoney }}</p>
			<p v-if="periodPayment">Payment: ${{ periodPayment | formatMoney }}</p>
		</div>
		<div v-if="programType == 'Lease'" class="tffi-card-secondary-with-bg-card__content">
			<p v-if="leaseTermMonths">Lease Term: {{ leaseTermMonths }} months</p>
			<p v-if="initialPaymentWithTax">Monthly Payment (tax included): ${{ initialPaymentWithTax | formatMoney }}</p>
			<p v-if="equipmentPrice">Equipment Value: ${{ equipmentPrice | formatMoney }}</p>
		</div>
		<div class="tffi-card-secondary-with-bg-card__overlay-image">
		</div>
		<div class="tffi-card-secondary-with-bg-card__bg">
		</div>
	</div>
</template>

<script>
export default {
	props: {
		financedAmount: {
			type: [Number, String],
			default: ''
		},
		periodPayment: {
			type: [Number, String],
			default: ''
		},
		programType: {
			type: String,
			default: ''
		},
		initialPayment: {
			type: [String, Number],
			default: null
		},
		initialPaymentWithTax: {
			type: [String, Number],
			default: null
		},
		equipmentPrice: {
			type: [String, Number],
			default: null
		},
		leaseTermMonths: {
			type: [String, Number],
			default: null
		},
		serviceTotal: {
			type: [String, Number],
			default: null
		},
		totalPaymentsWithTax: {
			type: [String, Number],
			default: null
		},
		apr: {
			type: [String, Number],
			default: null
		},
		applicationId: {
			type: [String, Number],
			default: null
		}
	},
	filters: {
		formatMoney(value) {
			return new Intl.NumberFormat('en-US', {
				minimumFractionDigits: 2,
				maximumFractionDigits: 2,
			}).format(Number(value || 0));
		},
		formatPercent(value) {
			return Number(value || 0).toFixed(2);
		}
	},
	data() {
		return {
		};
	},
	computed: {},
	watch: {},
	methods: {
		navigateToCalculator() {
			// Determine if this is a lease program
			// Check if programType prop is 'Lease' or if leaseTermMonths exists
			const isLease = this.programType === 'Lease' || this.leaseTermMonths;
			// Choose the appropriate calculator based on program type
			const calculatorName = isLease ? 'leaseCalculator' : 'loanCalculator';
			// Navigate to the appropriate calculator
			if (this.$route.params && this.$route.params.applicationId) {
				this.$router.push({
					name: calculatorName,
					params: { applicationId: this.$route.params.applicationId }
				});
			} else if (this.applicationId) {
				this.$router.push({
					name: calculatorName,
					params: { applicationId: this.applicationId }
				});
			} else {
				this.$router.push({ name: calculatorName });
			}
		}
	}
};
</script>

<style lang="scss" scoped>
</style>
